import { useState } from "react";

export default function Finance({ 
  startingBalance, 
  income, 
  expenses, 
  onChangeStartingBalance,
  onChangeIncome,
  onChangeExpenses 
}) {
  const [newIncomeTitle, setNewIncomeTitle] = useState("");
  const [newIncomeAmount, setNewIncomeAmount] = useState("");
  const [newExpenseTitle, setNewExpenseTitle] = useState("");
  const [newExpenseAmount, setNewExpenseAmount] = useState("");

  // Kalkulacije
  const start = Number(startingBalance) || 0;
  const totalIncome = income.reduce((sum, item) => sum + Number(item.amount), 0);
  const totalExpenses = expenses.reduce((sum, item) => sum + Number(item.amount), 0);
  const endingBalance = start + totalIncome - totalExpenses;

  // Prihodi
  const addIncome = () => {
    if (!newIncomeTitle.trim() || !newIncomeAmount) return;
    onChangeIncome([...income, { title: newIncomeTitle.trim(), amount: Number(newIncomeAmount) }]);
    setNewIncomeTitle("");
    setNewIncomeAmount("");
  };

  const removeIncome = (index) => {
    onChangeIncome(income.filter((_, i) => i !== index));
  };

  // Troškovi
  const addExpense = () => {
    if (!newExpenseTitle.trim() || !newExpenseAmount) return;
    onChangeExpenses([...expenses, { title: newExpenseTitle.trim(), amount: Number(newExpenseAmount) }]);
    setNewExpenseTitle("");
    setNewExpenseAmount("");
  };

  const removeExpense = (index) => {
    onChangeExpenses(expenses.filter((_, i) => i !== index));
  };

  return (
    <div>
      <h3>💰 Finansije</h3>

      {/* Početno stanje */}
      <div className="finance-row">
        <label>
          Stanje na početku dana:
          <input
            type="number"
            value={startingBalance}
            onChange={(e) => onChangeStartingBalance(e.target.value)}
            placeholder="0"
          />
        </label>
      </div>

      {/* Prihodi */}
      <div className="finance-subsection">
        <h4>📈 Prihodi</h4>
        <div className="input-row">
          <input
            type="text"
            value={newIncomeTitle}
            onChange={(e) => setNewIncomeTitle(e.target.value)}
            placeholder="Naziv prihoda..."
          />
          <input
            type="number"
            value={newIncomeAmount}
            onChange={(e) => setNewIncomeAmount(e.target.value)}
            placeholder="Iznos"
          />
          <button className="add" onClick={addIncome}>Dodaj</button>
        </div>

        {income.length > 0 && (
          <ul className="item-list">
            {income.map((item, index) => (
              <li key={index}>
                <span>{item.title}: <strong className="income-amount">+{item.amount}</strong></span>
                <button className="danger" onClick={() => removeIncome(index)}>✕</button>
              </li>
            ))}
          </ul>
        )}

        {totalIncome > 0 && (
          <div className="finance-subtotal">
            Ukupno prihodi: <strong className="income-amount">+{totalIncome}</strong>
          </div>
        )}
      </div>

      {/* Troškovi */}
      <div className="finance-subsection">
        <h4>📉 Troškovi</h4>
        <div className="input-row">
          <input
            type="text"
            value={newExpenseTitle}
            onChange={(e) => setNewExpenseTitle(e.target.value)}
            placeholder="Naziv troška..."
          />
          <input
            type="number"
            value={newExpenseAmount}
            onChange={(e) => setNewExpenseAmount(e.target.value)}
            placeholder="Iznos"
          />
          <button className="add" onClick={addExpense}>Dodaj</button>
        </div>

        {expenses.length > 0 && (
          <ul className="item-list">
            {expenses.map((item, index) => (
              <li key={index}>
                <span>{item.title}: <strong className="expense-amount">-{item.amount}</strong></span>
                <button className="danger" onClick={() => removeExpense(index)}>✕</button>
              </li>
            ))}
          </ul>
        )}

        {totalExpenses > 0 && (
          <div className="finance-subtotal">
            Ukupno troškovi: <strong className="expense-amount">-{totalExpenses}</strong>
          </div>
        )}
      </div>

      {/* Završno stanje */}
      <div className="finance-summary">
        <div className="finance-total">
          <span>💵 Stanje na kraju dana:</span>
          <strong className={endingBalance >= 0 ? "income-amount" : "expense-amount"}>
            {endingBalance}
          </strong>
        </div>
        <p className="finance-hint">
          Ovo stanje će biti početno stanje za sutra.
        </p>
      </div>
    </div>
  );
}
